var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAssistantDirection = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.162 20.185a9.6 9.6 0 0 1-3.82-.769 9.85 9.85 0 0 1-3.118-2.093 9.85 9.85 0 0 1-2.094-3.119 9.6 9.6 0 0 1-.769-3.82q0-2.049.769-3.831a9.9 9.9 0 0 1 2.094-3.108 9.85 9.85 0 0 1 3.118-2.094 9.6 9.6 0 0 1 3.82-.768q2.049 0 3.831.768a9.9 9.9 0 0 1 3.108 2.094 9.9 9.9 0 0 1 2.094 3.108q.768 1.782.768 3.83a9.6 9.6 0 0 1-.768 3.821 9.85 9.85 0 0 1-2.094 3.119 9.9 9.9 0 0 1-3.107 2.093q-1.783.77-3.832.769m-.557-2.874q.223.223.513.223a.7.7 0 0 0 .512-.223l6.415-6.415a.73.73 0 0 0 .223-.534.73.73 0 0 0-.223-.535L10.63 3.412a.7.7 0 0 0-.512-.223.7.7 0 0 0-.513.223L3.19 9.827a.73.73 0 0 0-.223.535.73.73 0 0 0 .223.534zm-3.029-4.276V9.47q0-.402.245-.646.245-.245.646-.245h3.698l-.936-.98 1.247-1.248 3.119 3.119-3.119 3.118-1.247-1.247.936-.98H8.358v2.673zm3.586 5.368q3.364 0 5.691-2.328t2.328-5.691-2.328-5.691q-2.327-2.328-5.69-2.328T4.47 4.693q-2.328 2.328-2.328 5.69 0 3.364 2.328 5.692t5.691 2.328"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAssistantDirection);
export default ForwardRef;